import { slicedToArray as _slicedToArray } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useEffect } from 'react';
import Blocks from './Blocks/index.js';
import Default from './Default/index.js';

var CountdownTimer = function CountdownTimer(_ref) {
  var startDate = _ref.startDate,
    endDate = _ref.endDate,
    style = _ref.style,
    text = _ref.text;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    timeLeft = _useState2[0],
    setTimeLeft = _useState2[1];
  var blockStyles = (style === null || style === void 0 ? void 0 : style.toLowerCase()) === 'blocks';
  useEffect(function () {
    var endUTC = new Date(endDate).toUTCString();
    var calculateTimeLeft = function calculateTimeLeft() {
      var now = new Date();
      if (now < new Date(startDate)) {
        return null;
      }
      var difference = new Date(endUTC) - now; // Using UTC for consistency

      if (difference > 0) {
        var days = Math.floor(difference / (1000 * 60 * 60 * 24));
        var hours = Math.floor(difference / (1000 * 60 * 60) % 24);
        var minutes = Math.floor(difference / 1000 / 60 % 60);
        return {
          days: days,
          hours: hours,
          minutes: minutes
        };
      }
      return {
        days: 0,
        hours: 0,
        minutes: 0
      };
    };
    setTimeLeft(calculateTimeLeft());
    var intervalId = setInterval(function () {
      setTimeLeft(calculateTimeLeft());
    }, 60000);
    return function () {
      return clearInterval(intervalId);
    };
  }, [startDate, endDate]);
  if (!timeLeft) {
    return null;
  }
  return blockStyles ? /*#__PURE__*/React__default.createElement(Blocks, {
    className: "countdown-timer",
    timeLeft: timeLeft,
    text: text
  }) : /*#__PURE__*/React__default.createElement(Default, {
    className: "countdown-timer",
    timeLeft: timeLeft
  });
};
var CountdownTimer$1 = CountdownTimer;

export { CountdownTimer$1 as default };
//# sourceMappingURL=index.js.map
